import React from 'react';
import { useAtomValue } from 'jotai';
import { Drawer } from '../../../../common/multi-level-drawer';
import { TASK_MODE } from '../../../../common/task-state/constants';
import { useEditAnnotationDrawer } from '../../../../modernization-common/side-panel/hooks/use-edit-annotation-drawer';
import { SidePanel } from '../../../../modernization-common/side-panel/side-panel';
import { StatefulSideDrawer } from '../../../../modernization-common/side-panel/stateful-side-drawer';
import { taskModeAtom } from '../../atoms/task-mode-atoms';
import { ReviewSidePanel } from './review-side-panel';
export function SidePanelContent() {
  const taskMode = useAtomValue(taskModeAtom);
  useEditAnnotationDrawer();
  return <>
      {taskMode === TASK_MODE.EDIT && <SidePanel />}
      {taskMode === TASK_MODE.REVIEW && <ReviewSidePanel />}

      <StatefulSideDrawer />
      <Drawer />
    </>;
}